export default __webpack_public_path__ + "static/media/scrn-4.2a0319ad.png";